import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _TypeNovelty } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import usePaginator from "../../../theme/Component/usePaginator";

export const TypeNovelty = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_TypeNovelty);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Tipo de Novedad", MODAL_SM);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getTypeNoveltyCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                // paginator.setPages(resp.NumberOfPages);
                // paginator.setRecords(resp.NumberOfPages * 15);

                resp.forEach(element => {
                    element.DataBeanProperties.EntityName = `${element.DataBeanProperties.Code ?? "N/P"} - ${element.DataBeanProperties.Name}`
                });

                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Tipos de Novedad");
        });
    };

    const create = () => {
        setBean({
            State: 1,
        });
        modal.open("Agregar Tipo de Novedad");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateTypeNovelty(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDTypeNovelty', visible: true },
        { title: 'Nombre', property: 'EntityName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar ${bean.Name}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipoes de Novedades de Permisos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Codigo</label>
                                <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, Code: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}